const INITIAL_STATE = {
    descontoReservaList: [],
    descontoReserva: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'DESCONTORESERVALIST_FETCH':
        return { ...state, descontoReservaList: action.payload }
      case 'DESCONTORESERVA_SET':
        return { ...state, descontoReserva: action.payload }
      default:
        return state
    }
  }
